import _ from 'lodash'
import md5 from './md5'

// const defaultAvatar = 'https://iupac.org/wp-content/uploads/2018/05/default-avatar.png'

const defaultAvatar = _.sample([
  'https://images.unsplash.com/photo-1528535661949-5dac90a11fb0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80',
  'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80'
])

export default (email = '', size = 80) => {
  if (email) return `http://www.gravatar.com/avatar/${md5(email)}.jpg?s=${size}&d=${defaultAvatar}`
}


